export const REQUIRED = ' This is Required';
export const PATTERN = 'This is Required';
export const MIN = 'Minimum value is  1';
export const MINLENGTH = 'Min Length should be';
export const MAXLENGTH = 'Max Length should be';
export const ALLOWED_DIGITS = 'Should be less than ';
export const FIVE_DIGITS_ONLY = 'Only allows 5 digits';
export const THREE_DIGITS_ONLY = 'Only allows 3 digits';
export const INVALID_CASE = 'Invalid factor.Valid Factor should be 123456.789';
